import React from "react";

function Contact() {
    return(
        <center>
            <iframe title="contact_form"
                src="https://docs.google.com/forms/d/e/1FAIpQLSdQFyjpavir6KHHEKd2n4GA1ZYGNgKw0JPhfXuiaeBhg5UiwQ/viewform?embedded=true"
                width="640" height="808" frameBorder="0" marginHeight="0" marginWidth="0">Loading…
            </iframe>
        </center>
    )

}
export default Contact;
